import useSWR, { SWRResponse } from 'swr';
import { getDocument } from '../../../providers/api/document/documentProvider';
import { Document } from '../../../providers/api/dtos';

export const DOCUMENT_RID = '/api/v1/documents/:id';

export default function useDocument(documentId?: number): SWRResponse<Document, Error> {
  return useSWR(documentId ? [DOCUMENT_RID, documentId] : null, () => getDocument(documentId!));
}
